var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"text-page"}},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"mb-2 page-title"},[_vm._v("PREGUNTAS FRECUENTES")]),_vm._v(" "),_c('div',{staticClass:"d-block",domProps:{"innerHTML":_vm._s(_vm.content.body)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }